import React from 'react';
import { useInactivityLogout } from '@/hooks/useInactivityLogout';

interface InactivityLogoutProviderProps {
  children: React.ReactNode;
  timeoutMinutes?: number;
  warningMinutes?: number;
  enabled?: boolean;
}

export const InactivityLogoutProvider: React.FC<InactivityLogoutProviderProps> = ({
  children,
  timeoutMinutes = 30,
  warningMinutes = 5,
  enabled = false // Disabled - tutors show offline when inactive but stay logged in
}) => {
  // Only initialize once using the singleton pattern in the hook
  useInactivityLogout({
    timeoutMinutes,
    warningMinutes,
    enabled
  });

  // Just render children - the hook handles everything
  return <>{children}</>;
};
